'use client'

import { type DependencyList, type EffectCallback, useEffect, useRef } from 'react'

export type UseEffectOnce = (
  callback: EffectCallback,
  dependecies: DependencyList,
  conditionToRun?: boolean
) => void

/**
 * Executes a given {@link callback} only once when a {@link conditionToRun} is true.
 *
 * @param callback -
 * Callback to be executed. Can return a cleanup function.
 * @param dependencies - Dependency array to be passed to `useEffect`.
 * @param conditionToRun - Boolean value.
 *
 */
export const useEffectOnce: UseEffectOnce = (callback, dependencies, conditionToRun = true) => {
  const isCalled = useRef(false)
  useEffect(() => {
    if (isCalled.current) return
    if (conditionToRun) {
      isCalled.current = true
      return callback()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback, ...dependencies, conditionToRun])
}
